module.exports = __webpack_public_path__ + "static/media/downArr.1361c71a.svg";